import { useState } from 'react';

import { useTranslation } from 'libs/i18n';
import { Pressed, Typography } from 'libs/ui';
import { cx } from 'libs/ui/theme';

import { ContentStyled } from './styles';

export interface CollapseTextProps {
  text: string;
}

export const CollapseText = ({ text }: CollapseTextProps) => {
  const { t } = useTranslation();

  const isShowAllButton = text && text.length > 100;

  const [showAllText, setShowAllText] = useState(!isShowAllButton);

  return (
    <ContentStyled>
      <Typography
        className={cx([
          'collapseText-text',
          showAllText && 'collapseText-textAll',
        ])}
        color="inherit"
      >
        {text}
      </Typography>
      {isShowAllButton && (
        <Pressed
          className="collapseText-button"
          onClick={() => setShowAllText((v) => !v)}
        >
          <Typography color="inherit" variant="captionSemiBold">
            {showAllText ? t('common.collapse') : t('common.showAll')}
          </Typography>
        </Pressed>
      )}
    </ContentStyled>
  );
};
